<template>
  <search-group title="" @search="flushData" @clear="clearValue"  :searchText="'刷新索引'">
    <Row :gutter="16">
      <Col span="4">
        <Select placeholder="类型" v-model="searchData.type">
          <Option value="">请选择</Option>
          <Option  v-for="item in conditionList" :value="item.value" :key="'keyA'+item.value">{{item.text}}</Option>
          <!--<option value=""></option>-->
        </Select>
      </Col>
      <Col span="6">
        <Input placeholder="项目/房型/房源Id" v-model="searchData.moduleFid"></Input>
      </Col>
    </Row>
  </search-group>

</template>
<script>
  // import SearchGroup from 'components/SearchGroup/index';

  export default {
    name: "SearchList",
    components: {
      // SearchGroup
    },
    props: {
    },
    data() {
      return {
        conditionList:[],  //{text:'禁止',value:0},{text:'显示',value:1}
        searchData: {
          page:1,
          limit:10,
          moduleFid:'',
          type:''
        },
        formRules:{
          moduleFid:[{ required: true, message: '请输入id' ,trigger: 'change', type:'string'}],
          type:[ {required:true, message: '请输选择类型', trigger: 'change', type: 'string'}]
        },
      }
    },
    methods:{
      flushData(){
        this.$emit('findData', this.searchData);
      },
      clearValue(){
        this.searchData={
          page:1,
          limit:10,
          moduleFid:'',
          type:''
        }
      },

    },
    created(){
      this.conditionList = [{text:'项目',value:1},{text:'房型',value:2},{text:'房源',value:3}]
    }

  }
</script>

<style scoped>

</style>
